import IDiagnosticOrderRequestParams from "../models/IDiagnosticOrderRequestParams";

class DiagnosticReportRequestParamsBuilder {

    resourceRequestParams: IDiagnosticOrderRequestParams;

    constructor() {
        this.resourceRequestParams = {
            patientId: null,
            completedOrder: null,
            withReports: null,
            reportGenOrder: null
        };
    }

    setPatientId(patientId: number): DiagnosticReportRequestParamsBuilder {
        this.resourceRequestParams.patientId = patientId;
        return this;
    }

    setCompletedOrder(completedOrder: boolean): DiagnosticReportRequestParamsBuilder {
        this.resourceRequestParams.completedOrder = completedOrder;
        return this;
    }

    setWithReports(withReports: boolean): DiagnosticReportRequestParamsBuilder {
        this.resourceRequestParams.withReports = withReports;
        return this;
    }

    setReportGenOrder(reportGenOrder: boolean): DiagnosticReportRequestParamsBuilder {
        this.resourceRequestParams.reportGenOrder = reportGenOrder;
        return this;
    }

    build(): IDiagnosticOrderRequestParams {
        return this.resourceRequestParams;
    }
}

export default DiagnosticReportRequestParamsBuilder